import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import { HTML_ATTRIBUTE_BLOCKER_CONNECTED } from ".";
import { render } from "react-dom";
import { WebsiteBlocker } from "../../components";
import { getSsrPoweredByLink } from "..";
import { getOtherOptionsFromWindow, getPreviousVisibleElement } from "../../utils";
import { probablyResetParentContainerForContentBlocker, findVisualParentForContentBlocker, HTML_ATTRIBUTE_BLOCKER_ID } from ".";
var connectedCounter = 0;
export var HTML_ATTRIBUTE_WAS_PREVIOUSLY_STRICT_HIDDEN = "consent-strict-hidden";
/**
 * Create visual content blocker for a given node.
 */

function createContentBlocker(_ref) {
  var _node$style, _createBefore$parentE, _createBefore$parentE2, _createBefore$parentE3, _secondParentPrevious;

  var node = _ref.node,
      blocker = _ref.blocker;
  // Visual content blockers are only allowed for "real" content
  var isPositioned = ["fixed", "absolute", "sticky"].indexOf((_node$style = node.style) === null || _node$style === void 0 ? void 0 : _node$style.position) > -1;
  var isNotInContent = [document.body, document.head, document.querySelector("html")].indexOf(node.parentElement) > -1;
  var isAlreadyConnected = node.getAttribute(HTML_ATTRIBUTE_BLOCKER_CONNECTED);
  var createBefore = findVisualParentForContentBlocker(node); // Always hide elements (again) if no visual blocker is possible (get) and memorize
  // the "!important" state so we can correctly reset it in `probablyResetParentContainerForContentBlocker`

  var fnStrictHide = function fnStrictHide() {
    if (["script", "link"].indexOf(node === null || node === void 0 ? void 0 : node.tagName.toLowerCase()) === -1) {
      var style = node.style;

      if (style.getPropertyValue("display") === "none" && style.getPropertyPriority("display") === "important") {
        node.setAttribute(HTML_ATTRIBUTE_WAS_PREVIOUSLY_STRICT_HIDDEN, "1");
      } else {
        style.setProperty("display", "none", "important");
      }
    }
  };

  if (isNotInContent || isPositioned || !(blocker !== null && blocker !== void 0 && blocker.visual) || isAlreadyConnected || !createBefore.offsetParent && !blocker.forceHidden) {
    fnStrictHide();
    return;
  }

  var container = document.createElement("div"); // Avoid duplicate visual blockers and connect them

  var previousElementSibling = createBefore.previousElementSibling;
  var firstParentPreviousElementSibling = (_createBefore$parentE = createBefore.parentElement) === null || _createBefore$parentE === void 0 ? void 0 : _createBefore$parentE.previousElementSibling;
  var secondParentPreviousElementSibling = (_createBefore$parentE2 = createBefore.parentElement) === null || _createBefore$parentE2 === void 0 ? void 0 : (_createBefore$parentE3 = _createBefore$parentE2.parentElement) === null || _createBefore$parentE3 === void 0 ? void 0 : _createBefore$parentE3.previousElementSibling;
  var possibleDuplicates = [getPreviousVisibleElement(createBefore), previousElementSibling, previousElementSibling === null || previousElementSibling === void 0 ? void 0 : previousElementSibling.lastElementChild, // 1st parent up
  firstParentPreviousElementSibling, firstParentPreviousElementSibling === null || firstParentPreviousElementSibling === void 0 ? void 0 : firstParentPreviousElementSibling.lastElementChild, // 2nd parent up
  secondParentPreviousElementSibling, secondParentPreviousElementSibling === null || secondParentPreviousElementSibling === void 0 ? void 0 : secondParentPreviousElementSibling.lastElementChild, secondParentPreviousElementSibling === null || secondParentPreviousElementSibling === void 0 ? void 0 : (_secondParentPrevious = secondParentPreviousElementSibling.lastElementChild) === null || _secondParentPrevious === void 0 ? void 0 : _secondParentPrevious.lastElementChild].filter(Boolean);

  var _iterator = _createForOfIteratorHelper(possibleDuplicates),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var possibleDuplicate = _step.value;

      if (+possibleDuplicate.getAttribute(HTML_ATTRIBUTE_BLOCKER_ID) === blocker.id && possibleDuplicate.hasAttribute(HTML_ATTRIBUTE_BLOCKER_CONNECTED)) {
        node.setAttribute(HTML_ATTRIBUTE_BLOCKER_CONNECTED, possibleDuplicate.getAttribute(HTML_ATTRIBUTE_BLOCKER_CONNECTED));
        fnStrictHide();
        return;
      }
    } // Connect blocker with blocked node

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  container.setAttribute(HTML_ATTRIBUTE_BLOCKER_CONNECTED, connectedCounter.toString());
  container.setAttribute(HTML_ATTRIBUTE_BLOCKER_ID, blocker.id.toString());
  container.className = "rcb-content-blocker";
  node.setAttribute(HTML_ATTRIBUTE_BLOCKER_CONNECTED, connectedCounter.toString());
  createBefore.parentNode.insertBefore(container, createBefore); // Do not translate this content blocker with an output buffer plugin like TranslatePress or Weglot

  var _getOtherOptionsFromW = getOtherOptionsFromWindow(),
      multilingualSkipHTMLForTag = _getOtherOptionsFromW.multilingualSkipHTMLForTag;

  if (multilingualSkipHTMLForTag) {
    container.setAttribute(multilingualSkipHTMLForTag, "1");
  } // Hide our element and render content blocker


  node.style.setProperty("display", "none", "important");
  render(h(WebsiteBlocker, {
    poweredLink: getSsrPoweredByLink(),
    blocker: blocker,
    connectedCounter: connectedCounter
  }), container);
  connectedCounter++;
  probablyResetParentContainerForContentBlocker(createBefore, true);
}

export { createContentBlocker };